const SPECIAL_SYMBOLS = ['\\', '+', '-', '&', '|', '!', '(', ')', '?', '{', '}', '"', '[', ']', ':'];

export const escapeSpecialSymbols = (string) => {
  let str = string.slice();
  for (let i = 0; i < SPECIAL_SYMBOLS.length; i++) {
    str = str.replaceAll(SPECIAL_SYMBOLS[i], `\\${SPECIAL_SYMBOLS[i]}`);
  }
  return str;
};
